<template>
    <div class="ranking-list-item" :class="{ me: isMe }">
        <div class="ranking-num" v-if="isMe">
            <p>我</p>
            <p class="color-red">{{ item.pkRank }}</p>
        </div>
        <div class="ranking-num" v-else>
            <div v-if="item.pkRank > 3">{{ item.pkRank }}</div>
            <img v-else :src="`https://staticwecom.beautyfarm.com.cn/wecom-workbench/2025-02-18/top${item.pkRank}.png`" alt="">
        </div>
        <div class="ranking-name" :class="nameWidth">
            <van-image class="img" v-if="status != '3'" round :src="item.avatar" error-icon="" />
            <div class="ellipsis font28" v-if="status == '3'">{{ item.sectionName }}</div>
            <div v-else class="ellipsis">
                <div class="font28">{{ item.assistantName }}</div>
                <div class="ellipsis font22">{{ item.sectionName }}</div>
            </div>
        </div>
        <div class="ranking-order" :class="orderWidth">{{ status == 2 ? item.nsgzSaleAmt : item.sgzSaleAmt }}w</div>
        <div class="ranking-bonus" v-if="status != '2'" :class="bonusWidth">{{ `${status == 1 ? item.allPoints || 0 : item.nsgzSaleAmt || 0}${status == '3' ? 'w' : ''}` }}</div>
    </div>
</template>

<script>
    export default {
        name: 'RankingItem',
        props: {
            item: {
                type: Object,
                default: () => { }
            },
            isMe: {
                type: Boolean,
                default: false
            },
            index: {
                type: Number,
                default: 0
            },
            status: {
                type: String,
                default: '1'
            },
        },
        data() {
            return {

            }
        },
        computed: {
            nameWidth() {
                return this.status !== "3" ? 'width320' : 'width200';
            },
            orderWidth() {
                return this.status === "1" ? 'width180' : this.status == 2 ? 'width240' : 'width160';
            },
            bonusWidth() {
                return this.status == 1 ? 'width100' : 'width200'
            }
        },
        methods: {
            // 获取主题色和图片和文字
            getTheme(type) {
                const index = this.status * 1 - 1
                const theme = {
                    cardBgColor: ['#FDE3D7', '#FDE3D7', '#F1DEA9', '#F6F2FF', '#F6F2FF'],
                    order: ['netAmtBfBcBody', 'custflowBfNetBcF0Mtd', 'saleAmtBfSelfBc', 'accountAmtMtd', 'accountAmtMtd'], // 金额对应字段
                }
                return theme[type][index];
            }
        }
    }
</script>

<style lang='less' scoped>
    .ranking-list-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        align-items: center;
        justify-content: space-between;
        // margin: 10px 0;
        padding: 30px 40px;
        border-bottom: 2px solid #eeeeee;

        &.me {
            padding: 20px;
            margin-top: 30px;
            background-color: #FDE3D7;
            border-radius: 12px;
            border: none;
        }

        &.title {
            padding-bottom: 0;
            border: none;
            color: #999999;
        }

        // &:nth-last-child(1) {
        //     border: none;
        // }

        .ranking-num {
            width: 75px;
            margin-right: 25px;

            .color-red {
                color: #AB080B;
            }

            >div {
                width: 50px;
                text-align: center;
            }

            >img {
                width: 50px;
                height: 60px;
            }
        }

        .ranking-name {
            display: flex;
            align-items: center;
            // width: 220px;

            div {
                // width: 100%;
            }

            >.img {
                width: 60px;
                height: 60px;
                min-width: 60px;
                margin-right: 10px;
            }

        }

        .ranking-order {
            // width: 200px;
            text-align: center;
        }

        .ranking-bonus {
            // width: 240px;
            text-align: center;
        }

    }

    .width100 {
        width: 100px;
    }

    .width160 {
        width: 160px;
    }

    .width180 {
        width: 180px;
    }

    .width200 {
        width: 200px;
    }

    .width220 {
        width: 220px;
    }

    .width240 {
        width: 240px;
    }

    .width320 {
        width: 320px;
    }
</style>
